<template>
  <div class="cancellation-container">
    <iframe
      v-if="$loginState()"
      ref="frame"
      :src="url"
      title="账号注销"
      @load="sendToken"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      url:
        process.env.VUE_APP_CANCEL_ACCOUNT_URL +
        "/closeAccount/logoutTips.html?app=spb&from=mini",
    };
  },
  mounted() {
    window.addEventListener("message", this.receiveMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.receiveMessage);
  },
  methods: {
    sendToken() {
      if (!this.$loginState()) {
        this.$wechatMiniProgramToLogin();
        return;
      }
      this.$refs.frame.contentWindow.postMessage(
        { token: localStorage.getItem("token") },
        new URL(this.url).origin,
      );
    },
    receiveMessage(event) {
      if (
        !this.$refs.frame ||
        event.source !== this.$refs.frame.contentWindow ||
        event.origin !== new URL(this.url).origin
      )
        return;
      const data = event.data || {};
      if (data.type === "logOut") this.$emit("logout");
      else if (data.type === "feedback") this.$router.push("/feedback");
    },
  },
};
</script>

<style scoped>
.cancellation-container {
  display: flex;
  flex: 1;
  min-height: 0;
}
iframe {
  width: 100%;
  flex: 1;
  min-height: 0;
  border: 0;
  background: #fff;
}
</style>
